/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.2.0-nightly.2025.12.25",
    versionName: "0.2.0-nightly.2025.12.25",
    versionChannel: "nightly",
    buildDate: "2025-12-25T00:09:15.019Z",
    commitHash: "43356876e32c9ff696e822659aecf252881b64c4",
};
